import { memo, type PropsWithChildren } from 'react';

import { WorkspaceOnboardingCard } from '~/components/WorkspaceOnboardingForm/WorkspaceOnboardingCard';

export type WorkspaceOnboardingContainerProps = PropsWithChildren;

export const WorkspaceOnboardingContainer = memo(({ children }: WorkspaceOnboardingContainerProps) => {
  return (
    <div data-disableselect="true" className="fixed inset-0 z-50">
      <div aria-hidden="true" className="absolute inset-0 bg-black/45 backdrop-blur-sm" />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="onboarding-dialog-title"
        className="relative z-10 flex h-full items-center justify-center px-4"
      >
        <WorkspaceOnboardingCard>{children}</WorkspaceOnboardingCard>
      </div>
    </div>
  );
});

WorkspaceOnboardingContainer.displayName = 'WorkspaceOnboardingContainer';
